import React, { useState, useEffect } from 'react';
import { ConfirmDialog } from '../../../confirm-dialog/confirm-dialog';

export interface IConfirmCompleteCoursesDialogComponentProps {
  open: boolean;
  onConfirmClick: () => void;
  onCancelClick?: () => void;
  coursesCount: number;
}

export function ConfirmCompleteCoursesDialogComponent(props: IConfirmCompleteCoursesDialogComponentProps) {
  const { open, onConfirmClick, onCancelClick, coursesCount } = props;

  const [isConfirmed, setIsConfirmed] = useState(false);

  useEffect(() => {
    if (open) {
      setIsConfirmed(false);
    }
  }, [open]);

  function handleConfirmClick() {
    setIsConfirmed(true);
    onConfirmClick && onConfirmClick();
  }

  return (
    <ConfirmDialog
      title="Ønsker du at afslutte holdene?"
      type="question"
      open={open}
      onConfirmClick={handleConfirmClick}
      onCancelClick={onCancelClick}
      confirmButtonText="Ja, afslut hold"
      cancelButtonText="Afbryd"
      cancelIsPrimary={false}
      isLoading={isConfirmed}
    >
      <p>Vil du markere {coursesCount > 1 ? `de ${coursesCount} valgte hold` : 'det valgte hold'} som afsluttet?</p>
    </ConfirmDialog>
  );
}
